import { render, staticRenderFns } from "./Follow.vue?vue&type=template&id=604b84ca&scoped=true&"
import script from "./Follow.vue?vue&type=script&lang=js&"
export * from "./Follow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604b84ca",
  null
  
)

export default component.exports